import { render, staticRenderFns } from "./ListSoftware.vue?vue&type=template&id=6540d36a&"
import script from "./ListSoftware.vue?vue&type=script&lang=js&"
export * from "./ListSoftware.vue?vue&type=script&lang=js&"
import style0 from "./ListSoftware.vue?vue&type=style&index=0&id=6540d36a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports